import { render } from "./PersonLight.vue?vue&type=template&id=43b79812&scoped=true"
import script from "./PersonLight.vue?vue&type=script&lang=js"
export * from "./PersonLight.vue?vue&type=script&lang=js"

import "./PersonLight.vue?vue&type=style&index=0&id=43b79812&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b79812"]])

export default __exports__